import { render } from "./userprofileedit.vue?vue&type=template&id=521e53c4&scoped=true"
import script from "./userprofileedit.vue?vue&type=script&lang=js"
export * from "./userprofileedit.vue?vue&type=script&lang=js"

import "./userprofileedit.vue?vue&type=style&index=0&id=521e53c4&scoped=true&lang=css"

import exportComponent from "E:\\lb\\vue30\\tuiguang_meng\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521e53c4"]])

export default __exports__